import React, { useState, useRef, useLayoutEffect } from 'react';
import prompts from 'shared/lib/prompts';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import useOutsideScroll from 'shared/lib/useOutsideScroll';
import { to } from 'react-spring';

const List = ({ onSelect, forwardRef, subMenuPosition }) => {
  const list = prompts();
  const [subs, setSubs] = useState(null);
  const [subsHorizontalPosition, setSubsHorizontalPosition] = useState({left: '100%', right: 'auto'});
  const subsRef = useRef(null);
  const menuListRef = useRef(null);

  useLayoutEffect(() => {
    if (subs && subsRef.current && menuListRef.current) {
      const subsRect = subsRef.current.getBoundingClientRect();
      const menuListRect = menuListRef.current.getBoundingClientRect();

      const rightPosition = menuListRect.right + subsRect.width;
      const spaceOnRight = window.innerWidth - rightPosition;

      if (spaceOnRight < subsRect.width + 10) {
        setSubsHorizontalPosition({
          left: 'auto',
          right: '100%',
        });
      } else {
        setSubsHorizontalPosition({
          left: '100%',
          right: 'auto',
        });
      }
    }
  }, [subs]);

  const renderItem = (item) => {
    const { name, icon, title, actions, prompt } = item;

    const promptItemHandle = () => {
      prompt ? onSelect(prompt) : setSubs(item);
    };

    return (
      <div key={name} onClick={promptItemHandle} className="s-prompts__button">
        <div className="s-prompts__link">
          <i className={`fi fi-${icon}`} />
          <div className="s-prompts__title">{title}</div>
          {actions && actions.length > 0 && <i className="fi fi-chevron-mini-right" />}
        </div>
      </div>
    );
  };

  const renderSubItem = (item) => {
    const { name, icon, title, actions, prompt } = item;

    if (!actions || actions.length === 0) return renderPrompt(item);

    return (
      <div key={name} className="s-prompts__sub">
        <div className="s-prompts__sub-title">{title}</div>
        <div className="s-prompts__actions">{actions.map(renderPrompt)}</div>
      </div>
    );
  };

  const renderPrompt = ({ name, title, prompt, icon }) => {
    return (
      <div key={name} onClick={() => onSelect(prompt)} className="s-prompts__action">
        {icon && <span className="s-prompts__action-icon">{icon}</span>}
        <span>{title}</span>
      </div>
    );
  };

  return (
    <>
      {createPortal(
        <div
          className={'s-prompts__menu'}
          ref={forwardRef}
          style={{
            top: `${subMenuPosition.top}px`,
            left: `${subMenuPosition.left}px`,
          }}
        >
          <div className={'s-prompts__list'} ref={menuListRef}>
            {list.map(renderItem)}
            {subs && (
              <div
                ref={subsRef}
                className="s-prompts__subs"
                style={{
                  left: subsHorizontalPosition.left,
                  right: subsHorizontalPosition.right,
                }}
              >
                <div className="s-prompts__subs-list">{subs.actions.map(renderSubItem)}</div>
              </div>
            )}
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default List;
